import { Snackbar, Alert, Slide } from '@mui/material';

// Slide-down transition component
const SlideDown = (props) => {
  return <Slide {...props} direction="down" />;
};

const SnackbarMessage = ({ open, message, severity, onClose }) => {
  // Updated clean modern colors
  const getStyles = (severity) => {
    switch (severity) {
      case 'success':
        return {
          backgroundColor: `var(--success)`, // blue for success (instead of green)
          color: '#fff',
        };
      case 'error':
        return {
          backgroundColor: `var(--error)`, // elegant deep red
          color: '#fff',
        };
      default:
        return {
          backgroundColor: '#444',
          color: '#fff',
        };
    }
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={2000}
      onClose={onClose}
      TransitionComponent={SlideDown} // 👈 animation
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert
        onClose={onClose}
        severity={severity}
        variant="filled"
        sx={{
          width: '100%',
          maxWidth: 500,
          boxShadow: 4,
          borderRadius: 2,
          fontSize: '1rem',
          fontWeight: 500,
          alignItems: 'center',
          ...getStyles(severity),
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default SnackbarMessage;
